var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 8.39944V12.8994C16 13.6155 16.2951 14.3023 16.8014 14.8086C17.3078 15.315 17.9362 15.5574 18.6523 15.5574C19.3684 15.5574 19.9362 15.1842 20.3118 14.8086C20.6873 14.4331 21 13.6155 21 12.8994V11.9994C20.9999 9.96816 20.3126 7.99667 19.0499 6.40552C17.7873 4.81437 16.0235 3.69714 14.0454 3.23551C12.0673 2.77387 9.99115 2.99498 8.15462 3.86287C6.31809 4.73076 4.82917 6.1944 3.92994 8.01579C3.03071 9.83718 2.77408 11.9092 3.20176 13.8949C3.62944 15.8807 4.71629 17.6633 6.28557 18.9531C7.85486 20.2428 9.81429 20.9637 11.8453 20.9987C13.8762 21.0336 15.8593 20.3804 17.472 19.1454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.5e7d2cc0ebd2dcdf6641a559e6b100b0.svg";
export { ForwardRef as ReactComponent };